import { SxProps, Theme } from '@mui/material';

type TStyles = {
  container: SxProps<Theme>;
};

export const styles: TStyles = {
  container: { height: 'fit-content', overflowY: 'scroll', maxHeight: '70%' },
};
